module.exports = __webpack_public_path__ + "static/Malaga-7161685017437d3841fa1c9bd1a30b70.png";